import React from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';
import PageNavigation from '@/components/common/PageNavigation';
import BLMParksIcon from '@/components/icons/BLMParks.svg';
import CanadaParksIcon from '@/components/icons/CanadaParks.svg';
import COEParksIcon from '@/components/icons/COEParks.svg';
import NationalForestParksIcon from '@/components/icons/NationalForestParks.svg';
import NationalParksIcon from '@/components/icons/NationalParks.svg';
import StateParksIcon from '@/components/icons/StateParks.svg';

import css from './TopNavigation.module.css';

const anchors = [
  { anchor: '#national', label: 'National Parks', icon: <NationalParksIcon /> },
  { anchor: '#state', label: 'State Parks', icon: <StateParksIcon /> },
  { anchor: '#canada', label: 'Canadian Parks', icon: <CanadaParksIcon /> },
  {
    anchor: '#nat_forest',
    label: 'National Forests',
    icon: <NationalForestParksIcon />,
  },
  { anchor: '#coe', label: 'COE Parks', icon: <COEParksIcon /> },
  { anchor: '#blm', label: 'BLM Parks', icon: <BLMParksIcon /> },
];

const TopNavigation = () => {
  return (
    <div className={css.navigation}>
      <MaxWidth className={`${css.innerWrapper} justify-center`}>
        <PageNavigation anchors={anchors} activeClass={css.active} />
      </MaxWidth>
    </div>
  );
};

export default TopNavigation;
